export default __webpack_public_path__ + "static/media/GalanoGrotesqueBold.a7e796fd.woff2";